import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as Sentry from '@sentry/node';
import get from 'lodash/get';
import styled from 'styled-components';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import Page404 from '@ertelecom/ui-react/components/layouts/404';
import { getCityFromHostName, getHostNameFromUrl } from '~/src/helpers/url';
import { getCitiesList, setCurrentCity } from '~/src/store/actions/city';
import { getMenuData } from '~/src/store/actions/menu';
import Layout from '~/src/layout/_layout';

const Container404 = styled.div`
    width: 100%;
    max-width: 985px;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 120px;
    @media only screen and (max-width: 1187px) {
        padding-top: 136px;
    }`;

function ErrorPage({ cityDomain = '', hostname = '', statusCode }) {
    const dispatch = useDispatch();

    const getData = useCallback(async() => {
        await dispatch(getCitiesList());
        dispatch(setCurrentCity(cityDomain));

        await dispatch(getMenuData());
    }, [cityDomain, dispatch]);

    useEffect(() => {
        getData();
    }, [getData]);

    useEffect(() => {
        if (statusCode === 404) {
            window.addEventListener('load', () => {
                dataLayerPush({
                    'event': 'UAevent',
                    'category': '404 error',
                    'action': window.location.href
                });
            });
        }
    }, [statusCode]);

    return (
        <Layout
            title='Страница не найдена'
            description='Страница не найдена'
            hostname={hostname}
            withMenu={true}
        >
            {statusCode === 404
                ? <Container404><Page404 currentCity={null} /></Container404>
                : null
            }

        </Layout>
    );
}

ErrorPage.getInitialProps = async(options) => {
    if (!process.browser) {
        const statusCode = options ? options.res.statusCode : options.err ? options.err.res.statusCode : null;

        if (!(statusCode === 404)) {
            Sentry.captureException(options.err);
        }

        const { req } = options;

        const headerHost = get(req, 'headers.host', '');
        const hostname = get(req, 'hostname', getHostNameFromUrl(headerHost));
        const cityDomain = getCityFromHostName(hostname);

        return { cityDomain, hostname, statusCode };
    }
};

export default ErrorPage;
